import moment from 'moment'
import { DATE } from '@/constants/constants'
import { uiHelper } from '@/utils'

export default function monthFormat(value) {
  let lang = uiHelper.getLocalStorage('language')
  moment.locale(lang === 'zh' ? 'zh-cn' : lang)
  let result = ''
  if (value != undefined && value != null && value != '') {
    return moment(value).format(DATE.MONTH)
  }

  return result
}
